import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat'
dayjs.extend(customParseFormat);

export function sortDateString(list, key, dateFormat) {
  list.sort((a, b) => {
    const dateA = dayjs(a[key], dateFormat);
    const dateB = dayjs(b[key], dateFormat);
    return dateA.valueOf() - dateB.valueOf();
  });
}


// WEBPACK FOOTER //
// ./src/utils/sort.js